export default __webpack_public_path__ + "static/heldane-text-bold-1c5809bc9f2e9ebbd2b4323959eb3bfc.woff2";